const apiUrl = process.env.REACT_APP_API_URL;
export const PostDuda = async ( id_aula : string,
                                id_usuari : string ,
                                dubte : string,
                                id_problema: any,
                                id_question: any,
                                id_practica: any,
                                id_projecte?: string,
                                id_tasca?: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/dubtes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id_aula, id_usuari, dubte, id_problema, id_question, id_practica, id_projecte, id_tasca })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
